import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties } from '../../common/utilities.js';
export function validateDynamicEmbedJson(dynamicEmbedJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // DynamicEmbedJson => RichAssetXXXXXX => RichAsset => Node
    const parentNode = dynamicEmbedJson.$container?.$container
        ?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: dynamicEmbedJson,
        allProperties: dynamicEmbedJson.properties,
        requiredProperties: [
            ast.TypeDynamicProperty,
            ast.SourceNodeProperty,
            ast.SourceVariableProperty,
        ],
        parentNode,
        accept,
    });
}
//# sourceMappingURL=dynamic-embed.js.map